import { ErrorMessage, Field, Formik, useFormik, Form } from "formik";
import DefaultButton from "../../../shared/components/DefaultButton";
import { CANCEL, HOURS_PER_WEEK, PART_FULL_TIME, SAVE } from "../../../shared/constants/Constants";

const FullPartTimeForm = ({ fullPartTime, submit, cancel }) => {
    const validate = (values) => {
        const errors = {};
        if (!values.name) {
            errors.name = "Required";
        }
        return errors;
    };

    return (
        <Formik
            initialValues={{
                id: fullPartTime?.id ?? null,
                name: fullPartTime?.name ?? "",
                hours_per_week: fullPartTime?.hours_per_week ?? ""
            }}
            validate={validate}
            onSubmit={submit}
            enableReinitialize
        >
            {() => (
                <Form className="row g-4">
                    <div className="col-md-6">
                        <label htmlFor="name" className="form-label">
                            {PART_FULL_TIME}<span className="error-text">*</span>
                        </label>
                        <Field
                            className="form-control"
                            type="text"
                            name="name"
                            placeholder={PART_FULL_TIME}
                            autoComplete="off"
                        />
                        <span className="error-text">
                            <ErrorMessage name="name" />
                        </span>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="hours_per_week" className="form-label">
                            {HOURS_PER_WEEK}
                        </label>
                        <Field
                            className="form-control"
                            type="text"
                            name="hours_per_week"
                            placeholder="Hours"
                            autoComplete="off"
                        />
                    </div>
                    <div className="col-md-12">
                        <DefaultButton
                            buttonClass={"btn btn-secondary me-2"}
                            buttonTitle={CANCEL}
                            actionBlock={cancel}
                        />
                        <DefaultButton
                            buttonClass={"default-btn-color"}
                            buttonTitle={SAVE}
                            buttonType={"submit"}
                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default FullPartTimeForm;
